import React from 'react';
import { Modal, Spin } from 'antd';

export const BookACallModalUI = ({ open, onClose, loading, onLoad, calendlySrc }) => {
    // Append Calendly params to hide its internal header & branding
    const separator = calendlySrc.includes('?') ? '&' : '?';
    const src = `${calendlySrc}${separator}hide_event_type_details=1&hide_gdpr_banner=1`;

    return (
        <Modal
            open={open}
            onCancel={onClose}
            footer={null}
            width={680}
            destroyOnClose
            centered
            closeIcon={
                <span style={{
                    color: 'rgba(255,255,255,0.85)', fontSize: 20, lineHeight: 1,
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                }}>
                    ×
                </span>
            }
            styles={{
                body:    { padding: 0, overflow: 'hidden', height: '620px' },
                content: { overflow: 'hidden', borderRadius: 12 },
                header:  {
                    background: 'linear-gradient(135deg, #314F71 0%, #1a2e45 100%)',
                    padding: '18px 24px',
                    margin: 0,
                    borderBottom: 'none',
                },
            }}
            title={
                <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
                    {/* Photo with translucent white ring */}
                    <img
                        src="/assets/media/avatars/SalesPerson.png"
                        alt="Expert avatar"
                        style={{
                            width: 54, height: 54, borderRadius: '50%',
                            objectFit: 'cover', flexShrink: 0,
                            border: '2.5px solid rgba(255,255,255,0.65)',
                            boxShadow: '0 2px 12px rgba(0,0,0,0.25)',
                        }}
                    />
                    {/* Heading + identity — all white on red */}
                    <div>
                        <div style={{ fontWeight: 700, fontSize: 17, color: '#fff', lineHeight: 1.3 }}>
                            Schedule a call with our P&amp;L expert
                        </div>
                        <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.78)', marginTop: 4, lineHeight: 1.4 }}>
                            with{' '}
                            <span style={{ fontWeight: 600, color: '#fff' }}>Himanshu Gaba</span>
                            {' · Co-Founder, SellerView.AI'}
                        </div>
                    </div>
                </div>
            }
        >
            <div style={{ position: 'relative', overflow: 'hidden', background: '#fff', height: 600 }}>
                {loading && (
                    <div
                        style={{
                            position: 'absolute', inset: 0, display: 'flex',
                            alignItems: 'center', justifyContent: 'center',
                            background: '#fff', zIndex: 1,
                        }}
                    >
                        <Spin size="large" tip="Loading scheduler..." />
                    </div>
                )}
                <iframe
                    src={src}
                    title="Book a Call – Calendly"
                    style={{
                        width: '100%',
                        height: 680,
                        border: 'none',
                        display: 'block',
                        marginTop: -50,
                    }}
                    onLoad={onLoad}
                />
            </div>
        </Modal>
    );
};

